// =============================================================================
// M&K PROPERTIES — EDITABLE SITE CONTENT
// -----------------------------------------------------------------------------
// This is the single place to edit company details, contact info, and images.
// Change the values below and the whole site updates automatically.
// =============================================================================

export const siteConfig = {
  company: {
    name: "M&K Properties",
    shortName: "M&K",
    descriptor: "Real Estate Investment & Development",
    location: "Greece",

    // --- CONTACT DETAILS (edit these) ---
    email: "info@mkproperties.eu",
    phone: "+44 7719975819",
  },

  // Where the contact form "sends" enquiries.
  // NOTE: The form currently only shows a professional success message (no
  // backend / email is wired up). To actually deliver enquiries, connect this
  // address to an email provider or backend endpoint later.
  contactFormDestination: "info@mkproperties.eu",

  // --- IMAGES (swap these URLs to change photography site-wide) ---
  images: {
    hero: "https://images.unsplash.com/photo-1595039357995-905cad2933e3?auto=format&fit=crop&w=2400&q=80",
    about: "https://images.unsplash.com/photo-1595330449916-e7c3e1962bd3?auto=format&fit=crop&w=1400&q=80",
    focusUrban: "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80",
    focusRenovation: "https://images.unsplash.com/photo-1707596830247-f4b161ffcff9?auto=format&fit=crop&w=1200&q=80",
    focusRental: "https://images.unsplash.com/photo-1565363887715-8884629e09ee?auto=format&fit=crop&w=1200&q=80",
  },
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "What We Do", href: "#what-we-do" },
  { label: "Investment Approach", href: "#investment-approach" },
  { label: "Contact", href: "#contact" },
];

export const reasonOptions = [
  "I want to sell a property",
  "I am a real estate agent or broker",
  "I am interested in investing",
  "I am a professional partner",
  "General enquiry",
];
